import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MutationInput } from 'src/app/api/graphql/mutation-input';
import { MatDialog } from '@angular/material/dialog';
import { MutationDialogComponent } from 'src/app/layouts/ui/mutation-dialog/mutation-dialog.component';
import {
    FormBlueprint,
    Selection,
    TextInput,
} from 'src/app/layouts/ui/form/formTypes';

@Injectable({
    providedIn: 'root',
})
export class ShortcutsService {
    router = inject(Router);
    snackbar = inject(MatSnackBar);
    dialog = inject(MatDialog);
    constructor() {}

    handelShortCut = (event?: string): boolean => {
        if (!event) return false;

        switch (this.shortcuts[event].type) {
            case 'navigate':
                this.router
                    .navigateByUrl(this.shortcuts[event].action)
                    .catch((error) =>
                        this.snackbar.open(
                            'Navigation Failed Check Url :(',
                            'Close',
                            { duration: 3000 },
                        ),
                    );
                return true;
            default:
                return false;
        }
    };

    addItem = (): void => {
        const addShortcut = new MutationInput(ADD_SHORTCUT);
        this.dialog
            .open(MutationDialogComponent, {
                data: {
                    mutationInput: addShortcut,
                    title: 'Create Shortcut',
                },
            })
            .afterClosed()
            .subscribe((request) => {
                if (request) {
                    let shortcut = request.input;
                    let newShortcuts = { ...this.shortcuts };
                    newShortcuts[shortcut.command] = { ...shortcut };
                    localStorage.setItem(
                        'shortcuts',
                        JSON.stringify(newShortcuts),
                    );
                }
            });
    };

    public get shortcuts(): { [key: string]: any } {
        return JSON.parse(localStorage.getItem('shortcuts') ?? '{}');
    }
}

const ADD_SHORTCUT: FormBlueprint = new FormBlueprint([
    {
        input: new TextInput({ placeholder: 'Command', required: true }),
        field: {
            key: 'command',
            value: (value: string) => {
                return { command: value };
            },
        },
    },
    {
        input: new Selection(
            { placeholder: 'ActionType', required: true },
            () => [{ name: 'Navigate', value: 'navigate' }],
        ),
        field: {
            key: 'type',
            value: (value?: string) => {
                return value ? { type: value } : { type: '' };
            },
        },
    },
    {
        input: new TextInput({ placeholder: 'Action' }),
        field: {
            key: 'action',
            value: (value: string) => {
                return { action: value };
            },
        },
    },
]);
